import BlurCircularOutlinedIcon from '@material-ui/icons/BlurCircularOutlined';
import NotInterestedOutlinedIcon from '@material-ui/icons/NotInterestedOutlined';
import { IGeneralPractitioner } from 'gen/ApiClient';
import React from 'react';

interface IProps {
	item: IGeneralPractitioner;
	style?: React.CSSProperties;
}

export const GeneralPractitionerListItemStatusIcon = ({ item, style }: IProps) => {
	if (item.isDeleted) {
		return <NotInterestedOutlinedIcon style={style} />;
	} else {
		return <BlurCircularOutlinedIcon style={style} />;
	}
};
